import { useTranslation } from 'react-i18next';

import MaskInput from 'components/MaskedInput';
import CropTypeField from 'features/Croptimizer/components/Fields/CropTypeField';

interface CropSectionProps {
  currentYield: string;
  setCurrentYield: (value: string) => void;
  initialCurrentYield: string;
  getErrorOfCurrentYield: string;
  mtHa: string;
}

export const CropSection = ({
  currentYield,
  setCurrentYield,
  initialCurrentYield,
  getErrorOfCurrentYield,
  mtHa,
}: CropSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className="border-b border-primitiveGrey break-inside-avoid">
      <div className="text-black font-bold text-xl md:text-lg mb-8">
        {t('crop')}
      </div>
      <div className="flex mx-[-0.5rem] mb-8">
        <div className="w-1/3 md:w-full px-2">
          <CropTypeField isGerman={true}/>
        </div>
        <div className="w-1/3 md:w-full px-2">
          <MaskInput
            titleClassName="top-[-9px] left-[8px] truncate max-w-[85%]"
            title={t('currentYield') + ` (${mtHa})`}
            className="w-full"
            isGreyText={initialCurrentYield === currentYield}
            value={currentYield}
            onChange={setCurrentYield}
            redBorder={getErrorOfCurrentYield?.length > 0}
          />
          <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
            {getErrorOfCurrentYield.length > 0 && (
              <div> {getErrorOfCurrentYield}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
